
module.exports = { 
      attributes: {},
    
      body: "Psychiatric services supports clients in diagnosis and treatment of people with mental illness. This may also include prescribing medication and developing a management plan for a client's treatment and recovery.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/psychiatric-services.md"},
     }